import React,{ useEffect } from 'react';
import styled from '@emotion/styled';
import Seo from "../components/SEO"

import PageHeadline from '../components/PageHeadline';
import { useLocalization } from "gatsby-theme-i18n";
import * as breakpoint from '../styles/breakpoints.module.scss';
import { getImage, withArtDirection } from "gatsby-plugin-image"
import { graphql } from 'gatsby';
import Logo from "../components/StyledComponents/Logo";
import CommentList from "../components/CommentList";

import CrosssiteBannerSection from '../sections/common/CrosssiteBannerSection';
const CommentBoard = ({ data }) => {
  const { t, addString, localeKey } = useLocalization();

  useEffect(() => {
    addString('comment_board',data.allCommentBoardCsv.nodes)
  },[addString,data]);

  return (<div>
    <Seo 
        title={data.pageTitle[localeKey]} 
        description={data.pageDescription[localeKey]}  />  
    <PageHeadline category={t('comment_board.page.category.label')} title={t('comment_board.page.display.title')} bgImg={
      withArtDirection(getImage(data.headlineBg), [
        {
          media: `(min-width: ${breakpoint.mdMin})`,
          image: getImage(data.headlineBg),
        },
        {
          media: `(max-width: ${breakpoint.smMax}) and (min-width: ${breakpoint.smMin})`,
          image: getImage(data.headlineBg_tablet),
        },
        {
          media: `(max-width: ${breakpoint.xsMax})`,
          image: getImage(data.headlineBg_mobile),
        }
      ])}/>
      <Introduction>
        <IntroLogo theme={'light'} />
      </Introduction>
      <CommentList />
      <CrosssiteBannerSection />
  </div>);
}
 
export default CommentBoard;

export const query = graphql`
  query CommentBoardPageQuery {
    pageTitle : commentBoardCsv(key: {regex: "/^page.title/"}) {
      ...localizedContent
    }
    pageDescription : commentBoardCsv(key: {regex: "/^page.description/"}) {
      ...localizedContent
    }

    allCommentBoardCsv {
      nodes {
        ...localizedContent
      }
    }

    headlineBg : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_pageHeader_commentBoard.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    headlineBg_tablet : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_pageHeader_commentBoard_tablet.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    headlineBg_mobile : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_pageHeader_commentBoard_mobile.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    
    
  }
`


const Introduction = styled.div`
  margin-top:-48px;
  padding-bottom:48px;
  background:#FCFCFF;

  
  @media only screen and (max-width: ${breakpoint.smMax}){
    margin-top:-32px;
    padding-bottom:32px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-top:-16px;
    padding-bottom:20px;
  }

  
`
const IntroLogo = styled(Logo)`
  width:288px;


  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:128px;
  }
`
